
<!-- 
  template for the <tabs></tabs> component 
  Usage override: 
    .tabs
      a(slot="tab-item") hoge
      a(slot="tab-item") hoge2
-->
<template lang="pug">
  .c-tabs(class="c-tab-block")
    slot(name="tab-item")
      .c-tab__item(v-for="(item, index) in items" v-bind:key="index" v-bind:class="{'active': (index + 1) == activate}" @click="handleClick(index)")
        router-link(v-if="isLink" v-bind:to="{ name: item.value }" replace) {{ item.label }}
        a(href="javascript:void(0)" v-if="!isLink" @click="handleClick(index)") {{ item.label }}
</template>

<script lang="babel">
  import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
  export default {
    name: "tabs",
    props: {
      items: {
        type: Array,
        default: [],
      },
      activate: {
        type: Number,
        default: 1,
      },
      notEventLink: {
        type: Boolean,
        default: false,
      }
    },
    data () {
      return {
      }
    },
    created () {
    },
    beforeRouteUpdate (to, from, next) {
    },
    computed: {
      isLink: {
        get () {
          if ( this.notEventLink ) {
            return false
          } else {
            return true
          }
        }
      }
    },
    methods: {
      handleClick (index) {
        // this.$emit('activate', index + 1)
        this.$emit('tab-click', index + 1)
      },

    }
  }
</script>

<style lang="scss">

</style>
